/*
 * @Description:
 * @Date: 2024-11-22 10:43:00
 */
import http from '@/utils/http/axios';
import { wwwConfig } from '@/utils/http/axios/content-type';
import { PwdLogIn, PhoneLogin, SetAPassword } from './types';

enum Api {
  sendMessageCode = '/back-end/api/v1/userSignIn/sendMessageCode', // 获取手机号验证码（发短信）
  phoneLogin = '/back-end/api/v1/userSignIn/user/phoneLogin', // 验证码登录（手机号）
  pwdLogIn = '/back-end/api/v1/userSignIn/user/pwdLogIn', // 账号密码登录
  setAPassword = '/back-end/api/v1/userSignIn/user/setAPassword', // 忘记密码/注册设置密码
  phoneRegistration = '/back-end/api/v1/userSignIn/user/phoneRegistration' // 手机号注册
}

const yApi = {
  // yapi: 1287
};

export const sendMessageCode = async params =>
  http.request(
    {
      url: Api.sendMessageCode,
      method: 'POST',
      params
    },
    { ...yApi, ...wwwConfig }
  );
export const phoneLogin: PhoneLogin = async params =>
  http.request(
    {
      url: Api.phoneLogin,
      method: 'POST',
      params
    },
    { ...yApi, ...wwwConfig }
  );
export const pwdLogIn: PwdLogIn = async params =>
  http.request(
    {
      url: Api.pwdLogIn,
      method: 'POST',
      params
    },
    { ...yApi, ...wwwConfig }
  );
export const setAPassword: SetAPassword = async params =>
  http.request(
    {
      url: Api.setAPassword,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
export const phoneRegistration: PhoneLogin = async params =>
  http.request(
    {
      url: Api.phoneRegistration,
      method: 'POST',
      params
    },
    { ...yApi, ...wwwConfig }
  );
